import { type ExperimentClient } from '@amplitude/experiment-js-client'
import { createContext, useContext } from 'react'

export type ExperimentContextValue = {
  client: ExperimentClient
  forcedVariants: Record<string, string>
} | null
export const ExperimentContext = createContext<ExperimentContextValue>(null)

export function useExperimentClient() {
  const client = useContext(ExperimentContext)
  if (!client) {
    throw new Error('Empty ExperimentContext')
  }

  return client
}
